<template>
  <div class="shift-end-page">
    <!-- 上方：新建结班 Tabs -->
    <el-tabs type="border-card" class="section-tabs">
      <el-tab-pane label="新建结班">
        <div class="new-shift-container">
          <el-form :model="settleForm" label-width="80px" size="small" inline>
            <el-form-item label="开始时间">
              <el-date-picker
                  v-model="settleForm.startTime"
                  type="datetime"
                  placeholder="开始时间"
                  disabled
                  value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                  v-model="settleForm.endTime"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="endPickerOptions"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="statLoading" @click="handleStatistics">统计</el-button>
              <el-button type="success" :loading="saveLoading" @click="handleSaveWithConfirm">保存结班</el-button>
            </el-form-item>
          </el-form>

          <!-- 统计结果展示 -->
          <div v-if="statisticsVisible" class="stat-result">
            <el-tabs v-model="activeStatTab" type="border-card" class="stat-tabs">
              <el-tab-pane label="收费汇总" name="fee">
                <div class="result-card">
                  <el-table :data="feeSummary" border size="small" class="summary-table">
                    <el-table-column prop="className" label="支付方式" min-width="150" align="center" />
                    <el-table-column prop="amount" label="金额(元)" align="center" width="150">
                      <template #default="{ row }">{{ (row.amount || 0).toFixed(2) }}</template>
                    </el-table-column>
                  </el-table>
                  <div class="total">收费合计：{{ (totalFeeAmount || 0).toFixed(2) }} 元</div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="挂号汇总" name="reg">
                <div class="result-card">
                  <el-table :data="regSummary" border size="small" class="summary-table">
                    <el-table-column prop="className" label="支付方式" min-width="150" align="center" />
                    <el-table-column prop="amount" label="金额(元)" align="center" width="150">
                      <template #default="{ row }">{{ (row.amount || 0).toFixed(2) }}</template>
                    </el-table-column>
                  </el-table>
                  <div class="stat-info">
                    <span>挂号人次：{{ registerStats.regCount }}</span>
                    <span style="margin-left: 20px;">退号人次：{{ registerStats.cancelRegCount }}</span>
                    <span style="margin-left: 20px;">退费金额：{{ registerStats.refundAmount.toFixed(2) }} 元</span>
                  </div>
                  <div class="total">挂号合计：{{ (totalRegAmount || 0).toFixed(2) }} 元</div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="total-amount">结班总金额：{{ (totalAmount || 0).toFixed(2) }} 元</div>
            <el-form-item label="备注" style="margin-top: 10px;">
              <el-input v-model="settleForm.remarks" type="textarea" :rows="2" style="width: 400px;" />
            </el-form-item>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 下方：历史结班记录 Tabs -->
    <el-tabs type="border-card" class="section-tabs history-tabs">
      <el-tab-pane label="历史结班记录">
        <div class="history-container">
          <el-form :model="queryParams" size="small" inline>
            <el-form-item label="开始时间">
              <el-date-picker
                  v-model="queryParams.startTime"
                  type="datetime"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
              />
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                  v-model="queryParams.endTime"
                  type="datetime"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="searchHistory">查询</el-button>
              <el-button icon="el-icon-refresh-right" @click="resetHistory">重置</el-button>
            </el-form-item>
          </el-form>

          <el-table
              v-loading="historyLoading"
              :data="historyList"
              border
              row-key="id"
          >
            <el-table-column prop="startTime" label="开始时间" min-width="160" align="center" />
            <el-table-column prop="endTime" label="结束时间" min-width="160" align="center" />
            <el-table-column prop="amount" label="总金额" width="120" align="center">
              <template #default="{ row }">{{ (row.amount || 0).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="createTime" label="结班时间" min-width="160" align="center" :formatter="formatDateTime" />
            <el-table-column prop="remarks" label="备注" min-width="150" show-overflow-tooltip align="center" />
            <el-table-column label="操作" width="80" align="center">
              <template #default="{ row }">
                <el-button type="text" size="small" @click="showDetailDialog(row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container">
            <el-pagination
                background
                @size-change="handleHistorySizeChange"
                @current-change="handleHistoryCurrentChange"
                :current-page="historyPageNum"
                :page-sizes="[8, 16, 32]"
                :page-size="historyPageSize"
                :total="historyTotal"
                layout="total, sizes, prev, pager, next, jumper"
            />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 详情模态框 -->
    <el-dialog
        title="结班详情"
        :visible.sync="detailDialogVisible"
        width="65%"
        :close-on-click-modal="false"
        @close="handleDetailDialogClose"
    >
      <el-tabs v-model="activeDetailTab" type="border-card">
        <el-tab-pane label="收费信息" name="paymentInfo">
          <div class="summary-in-detail">
            <div class="summary-title">收费汇总（按支付方式）</div>
            <el-table :data="detailChargeSummary" border size="small" style="margin-bottom: 20px;">
              <el-table-column prop="className" label="支付方式" min-width="150" align="center" />
              <el-table-column prop="amount" label="金额(元)" align="center" width="150">
                <template #default="{ row }">{{ (row.amount || 0).toFixed(2) }}</template>
              </el-table-column>
            </el-table>
            <div class="summary-total">收费合计：{{ detailChargeTotalAmount }} 元</div>
          </div>
          <div class="detail-list">
            <div class="summary-title">收费明细列表</div>
            <el-table :data="detailChargeList" border v-loading="detailChargeLoading">
              <el-table-column type="index" label="行号" width="55" align="center" />
              <el-table-column
                  v-for="col in dynamicChargeColumns"
                  :key="col.prop"
                  :prop="col.prop"
                  :label="col.name"
                  align="center"
                  :min-width="col.width"
              >
                <template #default="{ row }">
                  {{ getChargeCellValue(col, row) }}
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-container" style="margin-top: 15px;">
              <el-pagination
                  background
                  @size-change="handleDetailChargeSizeChange"
                  @current-change="handleDetailChargeCurrentChange"
                  :current-page="detailChargePageNum"
                  :page-sizes="[8, 16, 32]"
                  :page-size="detailChargePageSize"
                  :total="detailChargeTotal"
                  layout="total, sizes, prev, pager, next, jumper"
              />
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="挂号信息" name="registrationInfo">
          <div class="summary-in-detail">
            <div class="summary-title">挂号汇总（按支付方式）</div>
            <el-table :data="detailRegSummary" border size="small" style="margin-bottom: 20px;">
              <el-table-column prop="className" label="支付方式" min-width="150" align="center" />
              <el-table-column prop="amount" label="金额(元)" align="center" width="150">
                <template #default="{ row }">{{ (row.amount || 0).toFixed(2) }}</template>
              </el-table-column>
            </el-table>
            <div class="summary-total">挂号合计：{{ detailRegTotalAmount }} 元</div>
          </div>
          <div class="detail-list">
            <div class="summary-title">挂号明细列表</div>
            <el-table :data="detailRegList" border v-loading="detailRegLoading">
              <el-table-column type="index" label="行号" width="55" align="center" />
              <el-table-column
                  v-for="col in regColumns"
                  :key="col.prop"
                  :prop="col.prop"
                  :label="col.name"
                  align="center"
                  :min-width="col.width"
              >
                <template #default="{ row }">
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-container" style="margin-top: 15px;">
              <el-pagination
                  background
                  @size-change="handleDetailRegSizeChange"
                  @current-change="handleDetailRegCurrentChange"
                  :current-page="detailRegPageNum"
                  :page-sizes="[8, 16, 32]"
                  :page-size="detailRegPageSize"
                  :total="detailRegTotal"
                  layout="total, sizes, prev, pager, next, jumper"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { addSettleAccounts, getLastSettleAccountsTime, getFeeList, getRegisterList } from '@/api/reservation/outpatientCharge'
import { getShiftEndStatisticsPage, getShiftEndStatisticsOneById } from '@/api/shiftEndStatistics/shiftEndStatistics'
import { getFeelistStaticsByFinance, getRegisterStaticsByFinance } from "@/api/statisticalReport/statisticalReport"
import { getFinanceclassList } from "@/api/clasificacionContable/clasificacionContable"
import { getChargeList } from '@/api/reservation/outpatientChargeList'
import { getAllReservation } from '@/api/reservation/reservationList'
import { getPatternPaymentList } from "@/api/patternPayment/patternPayment"

export default {
  name: 'ShiftEndPage',
  data() {
    return {
      settleForm: {
        startTime: '',
        endTime: '',
        remarks: ''
      },
      statLoading: false,
      saveLoading: false,
      statisticsVisible: false,
      feeSummary: [],
      regSummary: [],
      totalFeeAmount: 0,
      totalRegAmount: 0,
      totalAmount: 0,
      feeRawList: [],
      regRawList: [],
      endPickerOptions: {
        disabledDate: (time) => {
          if (this.settleForm.startTime) return time < new Date(this.settleForm.startTime)
          return false
        }
      },
      activeStatTab: 'fee',
      registerStats: {
        regCount: 0,
        cancelRegCount: 0,
        refundAmount: 0
      },
      historyList: [],
      historyLoading: false,
      historyPageNum: 1,
      historyPageSize: 8,
      historyTotal: 0,
      queryParams: {
        startTime: '',
        endTime: ''
      },
      financeClassOptions: [],
      dynamicPaymentMethods: [],
      baseChargeColumns: [
        { name: "健康序号", prop: "patId", width: 120 },
        { name: "姓名", prop: "patName", width: 100 },
        { name: "单据编号", prop: "docNum", width: 180 },
        { name: "冲销状态", prop: "nuyState", width: 100 },
        { name: "收费员", prop: "feeUserName", width: 100 },
        { name: "开单医生", prop: "bilgDrName", width: 100 },
        { name: "开单科室", prop: "bilgDepName", width: 120 },
        { name: "应收金额", prop: "receAmt", width: 100 },
        { name: "实收金额", prop: "paidAmt", width: 100 }
      ],
      afterChargeColumns: [
        { name: "退款金额", prop: "nuyAmt", width: 100 },
        { name: "支付方式", prop: "opeWay", width: 100 },
        { name: "收费时间", prop: "feeTime", width: 160 },
        { name: "冲销人", prop: "nuyUserName", width: 100 },
        { name: "冲销时间", prop: "nuyTime", width: 160 },
        { name: "冲销序号", prop: "nuyId", width: 100 }
      ],
      regColumns: [
        { name: "健康ID", prop: "patientId", width: 100 },
        { name: "姓名", prop: "name", width: 100 },
        { name: "科室", prop: "regDepId", width: 100, op: 'deptOptions' },
        { name: "医生", prop: "regDoctorId", width: 100, op: 'doctorOptions' },
        { name: "应收金额", prop: "receivableMoney", width: 100 },
        { name: "实收金额", prop: "receivedMoney", width: 100 },
        { name: "挂号时间", prop: "createTime", width: 160 }
      ],
      detailDialogVisible: false,
      activeDetailTab: 'paymentInfo',
      detailChargeList: [],
      detailChargeLoading: false,
      detailChargePageNum: 1,
      detailChargePageSize: 8,
      detailChargeTotal: 0,
      detailRegList: [],
      doctorOptions: [],
      deptOptions: [],
      detailRegLoading: false,
      detailRegPageNum: 1,
      detailRegPageSize: 8,
      detailRegTotal: 0,
      currentDetailStartTime: '',
      currentDetailEndTime: '',
      detailChargeSummary: [],
      detailRegSummary: [],
      detailChargeTotalAmount: 0,
      detailRegTotalAmount: 0
    }
  },
  computed: {
    dynamicChargeColumns() {
      const paymentColumns = this.dynamicPaymentMethods.map(method => ({
        name: method.wayName,
        prop: `payment_${method.id}`,
        width: 120,
        isDynamic: true,
        wayId: method.id
      }))
      return [...this.baseChargeColumns, ...paymentColumns, ...this.afterChargeColumns]
    }
  },
  async created() {
    await this.loadPaymentMethods()
    await this.loadLastSettleTime()
    this.fetchHistory()
    this.getFinanceClassList()
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'] || []
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || []
  },
  methods: {
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
    async getFinanceClassList() {
      try {
        this.financeClassOptions = await getFinanceclassList()
      } catch (error) {
        console.error('加载财务分类失败:', error)
        this.$message.error('加载财务分类失败')
      }
    },
    async loadPaymentMethods() {
      try {
        const res = await getPatternPaymentList()
        if (res.code === 200 && res.data) {
          this.dynamicPaymentMethods = res.data
        } else {
          console.warn('获取支付方式列表失败，使用默认空列表')
          this.dynamicPaymentMethods = []
        }
      } catch (error) {
        console.error('加载支付方式失败:', error)
        this.dynamicPaymentMethods = []
      }
    },
    getPayWayName(classId) {
      // ✅ 用 == 兼容字符串/数字 classId
      const found = this.financeClassOptions.find(item => item.id == classId)
      return found ? found.name : `分类${classId}`
    },
    formatDateTime(row, col, val) {
      return val ? dayjs(val).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    async loadLastSettleTime() {
      try {
        const res = await getLastSettleAccountsTime()
        if (res.code === 200 && res.data && res.data.endTime) {
          this.settleForm.startTime = res.data.endTime
        } else {
          this.settleForm.startTime = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        this.settleForm.endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      } catch (error) {
        console.error('获取上次结班时间失败', error)
        this.settleForm.startTime = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.settleForm.endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    async handleStatistics() {
      if (!this.settleForm.endTime) {
        this.$message.warning('请填写结束时间')
        return
      }
      let startTime = this.settleForm.startTime
      if (!startTime) {
        startTime = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.$message.warning('未找到上次结班时间，已使用当天开始时间')
      }
      if (dayjs(this.settleForm.endTime).isBefore(startTime)) {
        this.$message.error('结束时间不能早于开始时间')
        return
      }
      this.statLoading = true
      try {
        const [feeRes, regRes, feeListRes, registerListRes] = await Promise.all([
          getFeelistStaticsByFinance({ startTime: startTime, endTime: this.settleForm.endTime }),
          getRegisterStaticsByFinance({ startTime: startTime, endTime: this.settleForm.endTime }),
          getFeeList({ startTime: startTime, endTime: this.settleForm.endTime, payState: 1 }),
          getRegisterList({ startTime: startTime, endTime: this.settleForm.endTime, payState: 1 })
        ])

        if (feeRes.code === 200 && feeRes.data) {
          this.feeRawList = feeRes.data
          const feeMap = new Map()
          feeRes.data.forEach(item => {
            const classId = item.classId
            const amount = item.amount || 0
            feeMap.set(classId, (feeMap.get(classId) || 0) + amount)
          })
          this.feeSummary = Array.from(feeMap.entries()).map(([classId, amount]) => ({
            classId,
            amount,
            className: this.getPayWayName(classId)
          }))
          this.totalFeeAmount = this.feeSummary.reduce((sum, item) => sum + item.amount, 0)
        } else {
          this.$message.error(feeRes.message || '收费统计失败')
          return
        }

        if (regRes.code === 200 && regRes.data) {
          this.regRawList = regRes.data
          const regMap = new Map()
          regRes.data.forEach(item => {
            const classId = item.classId
            const amount = item.amount || 0
            regMap.set(classId, (regMap.get(classId) || 0) + amount)
          })
          this.regSummary = Array.from(regMap.entries()).map(([classId, amount]) => ({
            classId,
            amount,
            className: this.getPayWayName(classId)
          }))
          this.totalRegAmount = this.regSummary.reduce((sum, item) => sum + item.amount, 0)
        } else {
          this.$message.error(regRes.message || '挂号统计失败')
          return
        }

        if (feeListRes.code === 200 && feeListRes.data) {
          const refundTotal = feeListRes.data.reduce((sum, item) => sum + (item.nuyAmt || 0), 0)
          this.registerStats.refundAmount = refundTotal
        }
        if (registerListRes.code === 200 && registerListRes.data) {
          const regList = registerListRes.data
          this.registerStats.regCount = regList.length
          this.registerStats.cancelRegCount = regList.filter(item => item.regState === 1).length
        }

        this.totalAmount = this.totalFeeAmount + this.totalRegAmount
        this.statisticsVisible = true
      } catch (error) {
        console.error('统计失败', error)
        this.$message.error('统计接口异常')
      } finally {
        this.statLoading = false
      }
    },
    handleSaveWithConfirm() {
      this.$confirm('确定要保存本次结班记录吗？保存后无法修改', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleSave()
      }).catch(() => {
        this.$message.info('已取消保存')
      })
    },
    async handleSave() {
      if (!this.statisticsVisible) {
        this.$message.warning('请先进行统计')
        return
      }
      this.saveLoading = true
      try {
        const params = {
          amount: this.totalAmount,
          // ✅ 修正：使用本次结班实际开始时间，不再写死当天 0 点
          startTime: this.settleForm.startTime,
          endTime: this.settleForm.endTime,
          feeAmount: this.totalFeeAmount,
          feeFinances: this.feeRawList.map(item => ({ amount: item.amount, classId: item.classId, id: item.id })),
          regAmount: this.totalRegAmount,
          regFinances: this.regRawList.map(item => ({ amount: item.amount, classId: item.classId, id: item.id })),
          remarks: this.settleForm.remarks
        }
        const res = await addSettleAccounts(params)
        if (res.code === 200) {
          this.$message.success('结班保存成功')
          this.statisticsVisible = false
          this.feeSummary = []
          this.regSummary = []
          this.feeRawList = []
          this.regRawList = []
          this.settleForm.remarks = ''
          await this.loadLastSettleTime()
          await this.fetchHistory()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (error) {
        console.error('保存异常', error)
        this.$message.error('保存异常')
      } finally {
        this.saveLoading = false
      }
    },
    processChargeDataWithPayWays(data) {
      if (!data || !Array.isArray(data)) return []
      return data.map(item => {
        const processedItem = { ...item }
        this.dynamicPaymentMethods.forEach(method => {
          processedItem[`payment_${method.id}`] = 0
        })
        if (item.payWay && Array.isArray(item.payWay)) {
          item.payWay.forEach(pay => {
            const matchedMethod = this.dynamicPaymentMethods.find(m => m.id === pay.wayId)
            if (matchedMethod) {
              processedItem[`payment_${matchedMethod.id}`] = pay.amount || 0
            }
          })
        }
        if (item.feeTime) processedItem.feeTime = dayjs(item.feeTime).format('YYYY-MM-DD HH:mm:ss')
        if (item.nuyTime) processedItem.nuyTime = dayjs(item.nuyTime).format('YYYY-MM-DD HH:mm:ss')
        return processedItem
      })
    },
    async fetchHistory() {
      this.historyLoading = true
      try {
        const params = { pageNum: this.historyPageNum, pageSize: this.historyPageSize, ...this.queryParams }
        if (!params.startTime) delete params.startTime
        if (!params.endTime) delete params.endTime
        const res = await getShiftEndStatisticsPage(params)
        if (res.code === 200) {
          this.historyList = res.data.content || []
          this.historyTotal = res.data.totalSize || 0
        } else {
          this.$message.error(res.message || '查询失败')
        }
      } catch (error) {
        console.error('获取历史结班列表失败', error)
      } finally {
        this.historyLoading = false
      }
    },
    searchHistory() { this.historyPageNum = 1; this.fetchHistory() },
    resetHistory() { this.queryParams = { startTime: '', endTime: '' }; this.historyPageNum = 1; this.fetchHistory() },
    handleHistorySizeChange(val) { this.historyPageSize = val; this.historyPageNum = 1; this.fetchHistory() },
    handleHistoryCurrentChange(val) { this.historyPageNum = val; this.fetchHistory() },

    // ✅ 详情弹窗：汇总调详情接口，明细仍按时间段查
    async showDetailDialog(row) {
      this.currentDetailStartTime = dayjs(row.startTime).format('YYYY-MM-DD HH:mm:ss')
      this.currentDetailEndTime   = dayjs(row.endTime).format('YYYY-MM-DD HH:mm:ss')
      this.detailDialogVisible = true
      this.detailChargePageNum = 1
      this.detailRegPageNum = 1
      this.activeDetailTab = 'paymentInfo'

      // 先清空，避免残留上一条
      this.detailChargeSummary = []
      this.detailRegSummary = []
      this.detailChargeTotalAmount = 0
      this.detailRegTotalAmount = 0

      await Promise.all([
        this.loadDetailSummaryById(row.id),
        this.loadDetailChargeList(),
        this.loadDetailRegList()
      ])
    },
    handleDetailDialogClose() {
      this.detailChargeList = []
      this.detailRegList = []
      this.detailChargeSummary = []
      this.detailRegSummary = []
      this.currentDetailStartTime = ''
      this.currentDetailEndTime = ''
    },

    // ✅ 汇总：调详情接口，基于 detailRespVO 生成
    async loadDetailSummaryById(id) {
      try {
        const res = await getShiftEndStatisticsOneById(id)
        if (res.code !== 200 || !res.data) {
          this.$message.error(res.message || '获取结班详情失败')
          return
        }
        const details = res.data.detailRespVO || []

        // type: 1挂号 2门诊；用 == 兼容字符串/数字
        const regDetails = details.filter(d => d.type == 1)
        const feeDetails = details.filter(d => d.type == 2)

        // 收费汇总
        const feeMap = new Map()
        feeDetails.forEach(item => {
          const k = item.classId
          feeMap.set(k, (feeMap.get(k) || 0) + Number(item.amount || 0))
        })
        this.detailChargeSummary = Array.from(feeMap.entries()).map(([classId, amount]) => ({
          classId,
          amount,
          className: this.getPayWayName(classId)
        }))
        this.detailChargeTotalAmount = Number(
            this.detailChargeSummary.reduce((s, i) => s + i.amount, 0).toFixed(2)
        )

        // 挂号汇总
        const regMap = new Map()
        regDetails.forEach(item => {
          const k = item.classId
          regMap.set(k, (regMap.get(k) || 0) + Number(item.amount || 0))
        })
        this.detailRegSummary = Array.from(regMap.entries()).map(([classId, amount]) => ({
          classId,
          amount,
          className: this.getPayWayName(classId)
        }))
        this.detailRegTotalAmount = Number(
            this.detailRegSummary.reduce((s, i) => s + i.amount, 0).toFixed(2)
        )
      } catch (e) {
        console.error('加载详情汇总失败', e)
        this.$message.error('加载详情汇总失败')
      }
    },

    async loadDetailChargeList() {
      if (!this.currentDetailStartTime || !this.currentDetailEndTime) return
      this.detailChargeLoading = true
      try {
        const res = await getChargeList({
          pageNum: this.detailChargePageNum,
          pageSize: this.detailChargePageSize,
          startTime: this.currentDetailStartTime,
          endTime: this.currentDetailEndTime
        })
        if (res.code === 200) {
          // ✅ 兼容返回结构：数组 / content / records
          const d = res.data
          const rawData = Array.isArray(d) ? d : (d.content || d.records || [])
          this.detailChargeList = this.processChargeDataWithPayWays(rawData)
          this.detailChargeTotal = Array.isArray(d) ? d.length : (d.totalSize || d.total || 0)
        } else {
          this.$message.error(res.message || '获取收费列表失败')
        }
      } catch (error) {
        console.error('加载收费列表失败', error)
        this.$message.error('加载收费列表失败')
      } finally {
        this.detailChargeLoading = false
      }
    },
    async loadDetailRegList() {
      if (!this.currentDetailStartTime || !this.currentDetailEndTime) return
      this.detailRegLoading = true
      try {
        const params = { pageNum: this.detailRegPageNum, pageSize: this.detailRegPageSize, startTime: this.currentDetailStartTime, endTime: this.currentDetailEndTime }
        const res = await getAllReservation(params)
        if (res.code === 200) {
          this.detailRegList = res.data.content || []
          this.detailRegTotal = res.data.totalSize || 0
        } else {
          this.$message.error(res.message || '获取挂号列表失败')
        }
      } catch (error) {
        console.error('加载挂号列表失败', error)
        this.$message.error('加载挂号列表失败')
      } finally {
        this.detailRegLoading = false
      }
    },
    handleDetailChargeSizeChange(val) { this.detailChargePageSize = val; this.detailChargePageNum = 1; this.loadDetailChargeList() },
    handleDetailChargeCurrentChange(val) { this.detailChargePageNum = val; this.loadDetailChargeList() },
    handleDetailRegSizeChange(val) { this.detailRegPageSize = val; this.detailRegPageNum = 1; this.loadDetailRegList() },
    handleDetailRegCurrentChange(val) { this.detailRegPageNum = val; this.loadDetailRegList() },
    getChargeCellValue(col, row) {
      if (col.isDynamic) {
        const val = row[col.prop]
        return val !== undefined && val !== null ? Number(val).toFixed(2) : '0.00'
      }
      const val = row[col.prop]
      if (col.prop === 'opeWay') {
        const wayMap = { 0: '现场', 1: '网络', 2: '自助机', 3: '银医通' }
        return wayMap[val] || val
      }
      if (col.prop === 'nuyState') {
        const stateMap = { 0: '否', 1: '冲销原单', 2: '冲销负单' }
        return stateMap[val] || val
      }
      if (['receAmt', 'paidAmt', 'nuyAmt'].includes(col.prop)) {
        return val !== undefined && val !== null ? Number(val).toFixed(2) : '0.00'
      }
      return val ?? ''
    }
  }
}
</script>

<style lang="less" scoped>
.shift-end-page {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: 100%;
}

.section-tabs {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  /deep/ .el-tabs__header {
    margin-bottom: 0;
    background-color: #fff;
  }
  /deep/ .el-tabs__content {
    padding: 20px;
  }
}

.history-tabs {
  margin-bottom: 0;
}

.new-shift-container,
.history-container {
  background-color: #fff;
}

.stat-result {
  margin-top: 20px;

  .stat-tabs {
    margin-bottom: 16px;
    /deep/ .el-tabs__content {
      padding: 0 !important;
    }
  }

  .result-card {
    background-color: #fafafa;
    border-radius: 6px;

    .total {
      text-align: right;
      margin-top: 8px;
      font-weight: bold;
      color: #e6a23c;
    }
  }

  .summary-table {
    margin-top: 8px;
    /deep/ .el-table__header th {
      background-color: #ecf5ff;
    }
  }

  .total-amount {
    margin-top: 15px;
    text-align: right;
    font-size: 18px;
    font-weight: bold;
    color: #67c23a;
    background: #f0f9eb;
    padding: 10px 20px;
    border-radius: 4px;
  }

  .stat-info {
    margin-top: 8px;
    padding: 6px 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 13px;
    color: #606266;
    text-align: right;
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.summary-in-detail {
  margin-bottom: 20px;
  .summary-title {
    font-weight: bold;
    margin-bottom: 10px;
    border-left: 4px solid #409eff;
    padding-left: 10px;
  }
  .summary-total {
    text-align: right;
    margin-top: 8px;
    font-weight: bold;
    color: #e6a23c;
  }
}

.detail-list {
  .summary-title {
    font-weight: bold;
    margin-bottom: 10px;
    border-left: 4px solid #67c23a;
    padding-left: 10px;
  }
}
</style>